import { ComponentType, PropsWithChildren, useState } from 'react';
import styled from 'styled-components';
import { InfoProps, SVGInfo } from '.';
import { CloseIcon, useStyledTheme } from '../../..';
import { Flex, FlexGrow } from '../Flex';

const CloseInfoContainer = styled(Flex)`
  align-items: center;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;
export function CloseInfo({ Info = SVGInfo, children }: PropsWithChildren<{Info?: ComponentType<InfoProps>}>) {
  const [visible, setVisible] = useState<boolean>(true);

  const onClickClose = () => {
    setVisible(false);
  };

  const theme = useStyledTheme();

  return (
    <>
      {visible && (
        <Info>
          <CloseInfoContainer id="CloseInfoContainer">
            <FlexGrow>
              {children}
            </FlexGrow>
            <CloseButton onClick={onClickClose}>
              <CloseIcon fill={`${theme.colours.neutral[2]}`} width={`${theme.padding[3]}`} />
            </CloseButton>
          </CloseInfoContainer>
        </Info>
      )}
    </>
  );
}
